var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        "append-to-body": true,
        visible: _vm.dialogVisible,
        width: "40%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
        },
        [
          _c(
            "p",
            {
              staticStyle: {
                "margin-bottom": "0.05rem",
                "font-size": "0.22rem",
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.stockDetail.productNameCn
                      ? _vm.stockDetail.productNameCn
                      : _vm.stockDetail.productNameEn
                  ) +
                  " "
              ),
            ]
          ),
          _c(
            "p",
            {
              staticStyle: {
                "margin-bottom": "0.2rem",
                color: "#134247",
                "font-size": "0.25rem",
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.cancelTypeMap[_vm.stockDetail.cancelType]
                      ? _vm.cancelTypeMap[_vm.stockDetail.cancelType]
                      : "有条件退"
                  ) +
                  " "
              ),
            ]
          ),
          _vm._l(_vm.policyDetail, function (items, indexs) {
            return _c(
              "div",
              {
                key: indexs,
                staticStyle: {
                  "font-size": "0.16rem",
                  "line-height": "0.3rem",
                  "margin-bottom": "0.2rem",
                },
              },
              [
                _c(
                  "p",
                  {
                    staticStyle: {
                      color: "#134247",
                      "font-weight": "bold",
                      "font-size": "0.2rem",
                    },
                  },
                  [_vm._v(" " + _vm._s(items.name) + " ")]
                ),
                _vm._l(items.value, function (item, index) {
                  return _c("p", { key: index }, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#58595B",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v(_vm._s(item.name) + "：")]
                    ),
                    _c("span", [_vm._v(_vm._s(item.value))]),
                  ])
                }),
              ],
              2
            )
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }